import { cn } from '@foundation/utils/cn';

interface ILoadingSpinnerProps {
  readonly variant?: 'default' | 'white';
  readonly smallSize?: boolean;
  readonly tinySize?: boolean;
  readonly className?: string;
  readonly wrapperClassName?: string;
}

export function LoadingSpinner({
  variant = 'default',
  smallSize,
  tinySize,
  wrapperClassName,
}: ILoadingSpinnerProps) {
  return (
    <div
      className={cn(
        'h-fit w-fit m-0 cursor-wait text-gray-900',
        wrapperClassName,
      )}
    >
      <div
        className={cn('relative', wrapperClassName, {
          'size-4': tinySize,
          'size-8': smallSize,
          'size-16': !smallSize && !tinySize,
        })}
      >
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="absolute left-1/2 top-0 w-[9.375%] h-[50%] -ml-[4.6875%] animate-fade"
            style={{
              transformOrigin: 'bottom center',
              transform: `rotate(${i * 45}deg)`,
              animationDelay: `${-1 + i * 0.125}s`,
            }}
          >
            <div
              className={cn('w-full h-1/2 mt-1 rounded-full bg-gray-950', {
                'bg-white': variant === 'white',
              })}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
